import { AssetsContext } from './Assets.context';

import { useAssets, useLoadFonts } from './Assets.hooks';

export function Assets({ children }: ChildreProps) {
	const { fonts, isLoading, error } = useAssets();
	useLoadFonts(fonts);

	return (
		<AssetsContext.Provider
			value={{
				isLoading,
				error,
				fonts,
			}}
		>
			{children}
		</AssetsContext.Provider>
	);
}

export function Fonts(_props: ChildreProps) {}

interface ChildreProps {
	children: string | JSX.Element | JSX.Element[];
}
